module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Medium.86cf7191.woff";